export const ReuploadIcon = ({ className }: { className?: string }) => {
  return (
    <svg
      width="32"
      height="32"
      viewBox="0 0 32 32"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={className}
    >
      <rect width="32" height="32" rx="6" fill="black" fill-opacity="0.6" />
      <path
        d="M23.0833 10.5833H13.9167C10.8223 10.5833 8.5 12.8208 8.5 16"
        stroke="white"
        stroke-width="1.67"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
      <path
        d="M8.91699 21.4167H18.0837C21.1781 21.4167 23.5003 19.1792 23.5003 16"
        stroke="white"
        stroke-width="1.67"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
      <path
        d="M21.417 8.5C21.417 8.5 23.5003 10.0343 23.5003 10.5833C23.5003 11.1323 21.417 12.6667 21.417 12.6667"
        stroke="white"
        stroke-width="1.67"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
      <path
        d="M10.5833 19.3333C10.5833 19.3333 8.50001 20.8676 8.5 21.4166C8.49999 21.9656 10.5833 23.5 10.5833 23.5"
        stroke="white"
        stroke-width="1.67"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
    </svg>
  );
};

ReuploadIcon.displayName = 'ReuploadIcon';
